export const howClassinoHelpsYouSlides = [
  {
    subheader: 'پیشرفت تحصیلی',
    header: '400+ دوره متنوع و جامع برای همه پایه‌ها',
    content: ['کلاس‌های جذاب و تعاملی', 'تدریس صفر تا صد مطالب درسی', 'پیشرفت قدم به قدم در طی سال تحصیلی'],
    cta: {
      sub_text: '',
      link: '/courses?courses=&grades=&lessons=&professors=',
      text: 'مشاهده دوره‌ها'
    },
    bg_color: 'background: linear-gradient(135deg, rgba(255,26,64,1) 0%, rgba(255,26,236,1) 100%);'
  },
  {
    subheader: 'موفقیت در آزمون تیزهوشان',
    header: '200+ قبولی تیزهوشان و مدارس برتر (IQ)',
    content: ['دوره‌های پیشرفته IQ', 'آزمون‌های شبیه‌ساز', 'اساتید مجرب تیزهوشان و مدارس برتر'],
    cta: {
      sub_text: '',
      link: '/courses?courses=418%2C421&grades=&lessons=&professors=',
      text: 'مشاهده دوره‌ها'
    },
    bg_color: 'background: rgb(255,157,20);background: linear-gradient(135deg, rgba(255,157,20,1) 0%, rgba(255,26,64,1) 100%);'
  },
  {
    subheader: 'موفقیت در آزمون کنکور',
    header: 'صدها رتبه زیر 1000 ',
    content: ['اساتید کنکور مجرب و کاربلد', 'دوره‌های جامع برای همه رشته‌ها', 'دوره‌های تخصصی برای بهبود مهارت تست‌زنی'],
    cta: {
      sub_text: '',
      link: '/courses?courses=376%2C379%2C382%2C412%2C415&grades=&lessons=&professors=',
      text: 'مشاهده دوره‌ها'
    },
    bg_color: 'background: rgb(102,26,255);background: linear-gradient(135deg, rgba(102,26,255,1) 0%, rgba(0,111,255,1) 100%);'
  },
  {
    subheader: 'موفقیت در امتحان نهایی',
    header: '100+ دوره‌ مختص موفقیت در آزمون‌های تشریحی',
    content: ['تدریس عمیق مطالب برای همه رشته‌ها', 'دوره‌های تخصصی برای موفقیت در امتحانات نهایی', 'حل نمونه سوالات سال‌های قبل'],
    cta: {
      sub_text: '',
      link: '/courses?courses=&grades=&lessons=&professors=',
      text: 'مشاهده دوره‌ها'
    },
    bg_color: 'background: rgb(255,26,236);background: linear-gradient(135deg, rgba(255,26,236,1) 0%, rgba(102,26,255,1) 100%);'
  }
]
